











































































































import Vue from 'vue'
import { SnackbarStateEnum } from '@/types/enums'
import { hexToRgba } from '@/services/hex-to-rgba'
import ProgressCircular from '@/components/ProgressCircular.vue'
import { getFlag } from '@/services/flag-service'

interface ComponentData {
  loading: boolean
  saveLoading: boolean
  showSnackbar: boolean
  messageSnackbar: string
  snackbarState: number

  isCreate: boolean
  isEdit: boolean
  languageList: any[]
  selectedLanguage: any | null

  code: string | null
  bildList: any[]
  bild: any | null
  bezeichnung: string | null
  briefanredeAllgemein: string | null
  allgemeinName: boolean
  briefanredeMannlich: string | null
  mannlichName: boolean
  briefanredeWeiblich: string | null
  weiblichName: boolean
  kurzMannlich: string | null
  kurzWeiblich: string | null
  kurz: string | null
  lang: string | null
  sprache: number | null
}

export default Vue.extend({
  name: 'SettingsLanguages',

  components: {
    ProgressCircular
  },

  props: {

  },

  data (): ComponentData {
    return {
      loading: false,
      saveLoading: false,
      showSnackbar: false,
      messageSnackbar: '',
      snackbarState: 0,

      isCreate: false,
      isEdit: false,
      languageList: [],
      selectedLanguage: null,

      code: null,
      bildList: [],
      bild: null,
      bezeichnung: null,
      briefanredeAllgemein: null,
      allgemeinName: false,
      briefanredeMannlich: null,
      mannlichName: false,
      briefanredeWeiblich: null,
      weiblichName: false,
      kurzMannlich: null,
      kurzWeiblich: null,
      kurz: null,
      lang: null,
      sprache: null,
    }
  },

  computed: {
    snackbarColor (): boolean {
      return this.snackbarState === SnackbarStateEnum.Success
    },

    toolbarColor (): string {
      return hexToRgba(this.$vuetify.theme.themes.light.primary)
    },

    showInsertButton (): boolean {
      return true
    },

    isDisabledInsertButton (): boolean {
      return false
    },

    showUpdateButton (): boolean {
      return true
    },

    isDisabledUpdateButton (): boolean {
      return false
    },

    showDeleteButton (): boolean {
      return true
    },

    isDisabledDeleteButton (): boolean {
      return false
    }
  },

  methods: {
    getFlag (code: string): string {
      return getFlag(code)
    },

    onAddLanguageClick (): void {

    },

    onEditLanguageClick (): void {

    },

    onDeleteLanguageClick (): void {

    },

    onCancelClick (): void {

    },

    onSaveButtonClick (): void {

    },

    loadBuildList() {
      const context = require.context('@/assets/flags/', false, /\.png$/)
      const flagPaths = context.keys()
      this.bildList = flagPaths.map(path => {
        const code = path.replace('./', '').replace('.png', '')
        const text = code.replace('flag_', '')
        return {
          text: text.charAt(0).toUpperCase() + text.slice(1),
          value: code,
          flag: context(path),
        }
      }).sort((a, b) => a.text.localeCompare(b.text))
    },

    fetchData (): void {
      this.languageList = [
        {id: 1, label: 'Deutch', flag: 'switzerland'},
        {id: 2, label: 'English', flag: 'great_britain'},
        {id: 3, label: 'Italienisch', flag: 'italy'},
      ]
    }
  },

  mounted () {
    this.loadBuildList()
    this.fetchData()
  }
})
